export default __webpack_public_path__ + "static/media/escalera3.368facea.png";